<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 56 16"
  >
    <path
      d="M49,1.88v-.88h-3v.88h-3V15h9V1.88h-3Z"
      style="fill: #fff; fill-rule: evenodd"
    />
    <path
      d="M20.01,15h13.99V1l-13.99,14Z"
      style="fill: #fff; fill-rule: evenodd"
    />
    <path
      d="M0,4.02L9.02,15,18.04,4.02c-2.51-1.89-5.63-3.02-9.02-3.02S2.51,2.12,0,4.02Z"
      style="fill: #fff; fill-rule: evenodd"
    />
  </svg>
</template>